class createSeatplan {
    constructor($state) {
        this.key = 'create-seatplan';
        this.title = 'Create Seatplan';
        this.level = 'highlight';
        this.icon = 'fal fa-plus-circle';
        this.state = $state;
    }

    action(payload, store) {
        return this.state.go('app.seatplans.create', {store: store});
    }

}

angular
    .module('festzelt-os.seatplans')
    .factory('createSeatplan', [
        '$state',
        $state => new createSeatplan($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/create-seatplan.js